import React, { useEffect, useState } from 'react';
import Navlink from './Navlink';
import Button from './Button';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';

export const Navbar = ({ session }) => {
  const [onMobile, setOnMobile] = useState(window.innerWidth < 640);
  const [showMenu, setShowMenu] = useState(false);
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

  useEffect(() => {
    const handleResize = () => {
      setOnMobile(window.innerWidth < 640);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [theme]);

  const handleThemeSwitch = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    window.location.href = '/';
  };

  return (
    <div className="sticky z-10 top-0 flex flex-col sm:flex-row gap-5 p-3 dark:bg-zinc-900 bg-zinc-100 justify-start transition-all mb-4 shadow-md shadow-zinc-700 dark:shadow-black">
      {showMenu || !onMobile ? <>
        <button onClick={handleThemeSwitch}>
          {theme === 'dark' ? (
            <FontAwesomeIcon icon={faSun} size="xl" color="white" />
          ) : (
            <FontAwesomeIcon icon={faMoon} size="xl" />
          )}
        </button>
        <Navlink location="/dashboard">Dashboard</Navlink>
        <Navlink location="/resources">Resources</Navlink>
        <Navlink location="/assistant">Assistant</Navlink>
        {session ? <Button onClick={handleLogout} text="Log Out" type="danger"/> : null}
      </> : null}
      {onMobile ? <button
                    className="text-black dark:text-white font-bold text-xl"
                    onClick={() => {setShowMenu(!showMenu)}}>
                      {showMenu ? "Hide Menu" : "Show Menu"}
                  </button> : null}
    </div>
  );
};
